import script from "./BaseMenuView.vue?vue&type=script&lang=js"
export * from "./BaseMenuView.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__